module.exports = __webpack_public_path__ + "static/MondayMovies-5ddd31b1dbeef3633e19422fb00f5ebf.jpg";